// ProductGallery
class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.mainImage = this.querySelector('.hp-primary-display-img');
    this.thumbnails = this.querySelectorAll('.thumbnail-btn');
    this.scrollStrip = this.querySelector('[data-thumbnail-strip]');
    this.imageSources = Array.from(this.thumbnails).map(t => t.getAttribute('data-full-src'));
    this.currentIndex = 0;
    this.initGalleryEngine();
    this.initDragScrollEngine();
  }

  initGalleryEngine() {
     // Thumbnail clicks handled by IIFE in hp-main-product--gallery.liquid
  }
  
  initDragScrollEngine() {
    if (!this.scrollStrip) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;

    this.scrollStrip.addEventListener('mousedown', (e) => {
      isDown = true;
      this.scrollStrip.classList.add('is-dragging-active');
      startX = e.pageX - this.scrollStrip.offsetLeft;
      scrollLeft = this.scrollStrip.scrollLeft;
    });

    this.scrollStrip.addEventListener('mouseleave', () => {
      isDown = false;
      this.scrollStrip.classList.remove('is-dragging-active');
    });

    this.scrollStrip.addEventListener('mouseup', () => {
      isDown = false;
      this.scrollStrip.classList.remove('is-dragging-active');
    });

    this.scrollStrip.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.scrollStrip.offsetLeft;
      const walk = (x - startX) * 2; // Scroll Velocity Speed Controller Multiply factor
      this.scrollStrip.scrollLeft = scrollLeft - walk;
    });
  }

  updateMainDisplay() {
    this.mainImage = this.querySelector('.hp-primary-display-img');

    if (!this.imageSources.length || !this.mainImage) return;
    
    const targetSrc = this.imageSources[this.currentIndex];
    this.mainImage.style.opacity = '0.4';
    
    setTimeout(() => {
      this.mainImage.setAttribute('src', targetSrc);
      this.mainImage.setAttribute('data-index', this.currentIndex);
      this.mainImage.style.opacity = '1';
    }, 120);
   
    this.thumbnails.forEach(t => t.classList.remove('is-active-selected'));
    const activeThumb = this.thumbnails[this.currentIndex];
    if (activeThumb) {
      activeThumb.classList.add('is-active-selected');
      
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
}

// End HP Product Gallery Code

const formElement = document.querySelector('[data-product-form]');
const productJSON = window.pf_api.product.data;
const dialogEntry = document.querySelector('[data-dialog-entry]');
const $cartBtn = $('[data-add-to-cart]');
const $cartBtnText = $('[data-add-to-cart-text]');
const $frequencySelect = $('[data-freq-select]');
const $checkoutBtn = $('[data-checkout-now]');
const $priceWrapper = $('[data-price-wrapper]');
const $productPrice = $('[data-product-price]');
const $comparePrice = $('[data-compare-price]');
const $comparePriceText = $('[data-compare-text]');
//const $subscribeCheckbox = $('[data-subscribe]');

const $purchaseRadios = $('[data-purchase-type-radio]');
const $subscribeRadioTrigger = $('[data-subscribe-radio-trigger]');

const $gallerySlider = $('.js-product-images');
const qtySelect = document.querySelector('[data-qty-select]');
let pendingOrderLimitAdd = null;
let resumeAfterOrderLimit = false;

const productForm = new Shopify.theme.productForm.ProductForm(formElement, productJSON, {
  onOptionChange,
  onQuantityChange,
  onFormSubmit
});



function onOptionChange(event) {
  $checkoutBtn.removeClass('active');
  const variant = event.dataset.variant;
  if (!variant) {
    $cartBtn.prop('disabled', true);
    $cartBtnText.html(pf_api.strings.unavailable);
    $priceWrapper.addClass('hide');
    return;
  } else if (variant && !variant.available) {
    variantChangeHandler(variant);
  } else if (variant && variant.available) {
    variantChangeHandler(variant);
  }
  const url = Shopify.theme.productForm.getUrlWithVariant(window.location.href, variant.id);
  window.history.replaceState({ path: url }, '', url);
}

function onQuantityChange(event) {
  const quantity = event.dataset.quantity;
  $cartBtn.attr('data-variant-qty',quantity);
}

function consentDialogHandlers(dialog) {
  dialog.querySelector('[data-continue-consent]').addEventListener('click',event => {
    let variantId = event.target.dataset.variantId;
    let quantity = event.target.dataset.quantity;
    let subscription = JSON.parse(event.target.dataset.subscription);
    addItem(variantId, quantity, {}, subscription);
    hideDialog();
  });
}

function buildConsentDialog(handle, variantId, quantity, subscription) {
  let message;
  switch(handle) {
    case 'perfect-tone-pads':
      message = 'Attention!<br><strong>If your purchase contains Perfect Tone Pads with prescription hydroquinone,</strong> we require some additional information, including a completed consent form and makeup-free photos. Once your payment is processed, please look out for a follow-up email with further instructions. <br><strong>Your prompt response is essential to ensure we can prepare and ship your order without delay.*</strong>';
      break;
    case 'angelas-melasma-maintenance-lineup':
      message = 'To complete your purchase of this lineup, which contains Perfect Tone Pads, we require further information from you. You will receive a follow up email once your payment has been completed. Please respond to us so we can promptly ship out your order!*';
      break;
    default:
      message = 'To complete your purchase of this product, we require further information from you. You will receive a follow up email once your payment has been completed. Please respond to us so we can promptly ship out your order!*';
  }
  dialogEntry.innerHTML = `
    <div class="product-consent">
      <div class="dialog__header">Attention!</div>
      <div class="product-consent__title">${message}</div>
      <button type="button" class="button button--solid" data-continue-consent data-variant-id="${variantId}" data-quantity="${quantity}" data-subscription="${subscription}">Continue Add to Bag</button>
      <button type="button" class="button" data-close-dialog>Cancel</button>
      <div class="product-consent__disclaimer"><i>*Kindly note: This process must be completed every time you purchase Perfect Tone Pads with Hydroquinone.</i></div>
    </div>
  `;
  showDialog();
  consentDialogHandlers(dialogEntry);
}

function subscribeAndSaveHandlers(variantId, quantity, name) {
  $('[data-subscription-opt-in]').on('click',() => {
    addItem(variantId, quantity, {}, true, true);
    setTimeout(() => {
      buildSubscriptionConfirmationDialog(name);
    }, 350);
  });
  $('[data-subscription-opt-out]').on('click',() => {
    addItem(variantId, quantity, {}, false, false);
  });
}

function buildSubscriptionConfirmationDialog(name) {
  dialogEntry.innerHTML = `
    <div class="product-dialog__subscribe">
      <div>You’re all set!</div>
      <p>Thank you for subscribing for auto-replenish, the best way to enjoy a discount on your favorite products while receiving them hassle free! We have preset the delivery frequency in your Feel Good Bag to the recommended timing for this particular product. If you wish to change how often you receive this product, simply use the dropdown list in your shopping cart to select your desired frequency.</p>
      <p>As always, you can email us for assistance at <a href="mailto:feelgood@helloprfct.com">feelgood@helloprfct.com</a>.</p>
      <button type="button" class="button button--solid" data-close-dialog>Continue Shopping</button>
    </div>
  `;
  showDialog();
}

function buildSubscribeAndSaveDialog(variantId, quantity, name) {
  dialogEntry.innerHTML = `
    <div class="product-dialog__subscribe">
      <div>Get <span>&nbsp;10% off&nbsp;</span> when you auto&#8209;replenish ${name}!</div>
      <p>Save 10% today and on all future deliveries when you subscribe for Auto&#8209;Replenish. Just set it, forget and receive your new product before you run out.</p>
      <button type="button" class="button button--solid" data-subscription-opt-in data-close-dialog>Yes! Subscribe <span>to Auto-Replenish</span> for 10% off</button>
      <button type="button" data-subscription-opt-out data-close-dialog>Not today, thank you</button>
    </div>
  `;
  showDialog();
  subscribeAndSaveHandlers(variantId, quantity, name);
}

function buildOrderLimitDialog(variantId) {
  dialogEntry.innerHTML = `
    <div class="product-dialog__order-limit">
      <div class="dialog__header">Attention!</div>
      <div class="dialog__content paragraph_style mb-md-4 mb-3" style="font-weight:500">
        ${window.pf_api.product.variants[variantId].orderLimitReachedCopy}
      </div>
      <button
        type="button"
        class="button button--solid"
        data-continue-order-limit>
        Continue Add to Bag
      </button>
    </div>
  `;

  showDialog();

  dialogEntry
    .querySelector('[data-continue-order-limit]')
    .addEventListener('click', async () => {
      if (!pendingOrderLimitAdd) return;

      const {
        variantId,
        quantity,
        props,
        offersSubscription,
        subscription,
        name
      } = pendingOrderLimitAdd;

      pendingOrderLimitAdd = null;
      hideDialog();

      //  check if item already exists in cart
      const cart = await fetch('/cart.js').then(r => r.json());
      const alreadyInCart = cart.items.some(
        item => item.variant_id == variantId
      );

      // if already in cart, just activate checkout
      if (alreadyInCart) {
        $checkoutBtn.addClass('active');
        return;
      }

      //  otherwise, allow first-time add
      resumeAfterOrderLimit = true;

      addItem(
        variantId,
        quantity,
        props,
        offersSubscription,
        subscription,
        name
      );

      resumeAfterOrderLimit = false;
      $checkoutBtn.addClass('active');
    });
}


async function addItem(variantId, quantity, props, offersSubscription, subscription, name) {

  let sellingPlanId;

  if (pf_api.product.variants[variantId].orderLimit && !resumeAfterOrderLimit) {
  pendingOrderLimitAdd = {
    variantId,
    quantity,
    props,
    offersSubscription,
    subscription,
    name
  };

  buildOrderLimitDialog(variantId);
  return false;
}


  if (offersSubscription) {
    if (subscription) {
      sellingPlanId = $frequencySelect.val();
    } else {
      //buildSubscribeAndSaveDialog(variantId, quantity, name);
      //return false;
    }
  }

  const items = {
    items: [{ id: variantId, quantity, properties: props, selling_plan: sellingPlanId }]
  };
  fetch(window.pf_api.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(items)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    if (data.status === 422) {
      throw new Error('Woops! Not enough inventory!');
    }
    console.info('Add item success:',data);
    if (subscription) {
      gtmAddToCart('yes');
    } else {
      gtmAddToCart('no');
    }
    $checkoutBtn.addClass('active');
    dataLayerAdd(data,quantity);
    pf_api.cart[data.variant_id] = pf_api.cart[variantId] || {};
    pf_api.cart[data.variant_id].itemCount = data.quantity;
    setTimeout(function() {
      $checkoutBtn.removeClass('active')
    }, 4000);
  })
  .catch((error) => {
    console.error('addItem error:', error);
    alert(error);
  });
}

/*
function onFormSubmit(event) {
  let quantity = event.dataset.quantity;
  let offersSubscription = false;
  let subscription = false;
  let props = event.dataset.properties;
  let { id } = event.dataset.variant;
  let name = event.target.dataset.productTitle;
  const handle = event.target.dataset.productHandle;

  if ($subscribeCheckbox.length > 0) {
    offersSubscription = true;
    if ($subscribeCheckbox.prop('checked')) {
      subscription = true;
    }
  }

  if (event.target.dataset.productForm == 'consent-required') {
    buildConsentDialog(handle, id, quantity, subscription);
  } else {
    addItem(id, quantity, props, offersSubscription, subscription, name);
  }
}*/

function onFormSubmit(event) {
  let quantity = event.dataset.quantity;
  let offersSubscription = ($purchaseRadios.length > 0);
  let isSubscribed = $subscribeRadioTrigger.is(':checked');
  let props = event.dataset.properties;
  let { id } = event.dataset.variant;
  let name = event.target.dataset.productTitle;
  
  addItem(id, quantity, props, offersSubscription, isSubscribed, name);
}

function variantChangeHandler(variant) {
  updatePriceState(variant);
  updateVariantImage(variant);
  updateAddToCartState(variant);  
  updateOrderLimitQty(variant);
}

function updateQuantityOptions(limit) {
  if (!qtySelect) return;
  const options = [];
  for (let i = 1; i <= limit; i++) {
    options.push(`<option value="${i}">${i}</option>`);
  }
  qtySelect.innerHTML = options.join('');
}

function updateOrderLimitQty(variant) {
  if (!window.pf_api || !window.pf_api.product || !window.pf_api.product.variants || !window.pf_api.product.variants[variant.id]) {
    updateQuantityOptions(10);
    return;
  }
  const variantOrderLimit = window.pf_api.product.variants[variant.id].orderLimit;
  if (variantOrderLimit && variantOrderLimit > 0) {
    updateQuantityOptions(variantOrderLimit);
  } else {
    updateQuantityOptions(10);
  }
}

function updatePriceState(variant) {
  const $compareEls = $comparePrice.add($comparePriceText);  
  const isSubscribed = $subscribeRadioTrigger.is(':checked');

  const basePrice = variant.price / 100;
  const discountPrice = basePrice * 0.90;

  if (isSubscribed) {
    $productPrice.html(formatMoney(variant.price * 0.90, pf_api.moneyFormat));
    $productPrice.attr('data-strike-out-price', formatMoney(variant.price, pf_api.moneyFormat));
    $productPrice.attr('data-product-price', basePrice);
  } else {
    $productPrice.html(formatMoney(variant.price, pf_api.moneyFormat));
    $productPrice.attr('data-strike-out-price', ''); 
    $productPrice.attr('data-product-price', basePrice);
  }

  try {
    $('[data-one-time-box-price]').html(formatMoney(variant.price, pf_api.moneyFormat));
    $('[data-subscription-strike-price]').html(formatMoney(variant.price, pf_api.moneyFormat));
    $('[data-subscription-discount-price]').html(formatMoney(variant.price * 0.90, pf_api.moneyFormat));
  } catch(e) { 
    console.warn("Liquid explicit attribute handler bypassed:", e); 
  }
  if (variant.compare_at_price > variant.price) {
    $comparePrice.html(formatMoney(variant.compare_at_price, pf_api.moneyFormat));
    $compareEls.removeClass('hide');
  } else {
    $comparePrice.html('');
    $compareEls.addClass('hide');
  }
}

function updateAddToCartState(variant) {
  if (variant.available) {
    $priceWrapper.removeClass('hide');
    $cartBtn.prop('disabled', false);
    $cartBtnText.html(pf_api.strings.addToCart);
  } else {
    $priceWrapper.removeClass('hide');
    $cartBtn.prop('disabled', true);
    $cartBtnText.html(pf_api.strings.soldOut);
  }
}

function updateVariantImage(variant) {
  var mediaId = null;
  var imgUrl = null;
  if (variant.featured_image) {
    mediaId = variant.featured_image.id;
    imgUrl = variant.featured_image.src || variant.featured_image.url;
  } else if (variant.featured_media) {
    mediaId = variant.featured_media.id;
    imgUrl = variant.featured_media.preview_image?.src || variant.featured_media.src;
  } else if (variant.image_id) {
    mediaId = variant.image_id;
  }

  if (!mediaId && !imgUrl) return;
  document.dispatchEvent(new CustomEvent('variant:imageChange', {
    detail: { mediaId: mediaId, imgUrl: imgUrl }
  }));
}

function dataLayerAdd(variant, quantity) {
  dataLayer.push({
    'event': 'Add to Cart',
    'logged_in': pf_api.customer.loggedIn,
    'category': 'Conversion Funnel',
    'label': 'Add to Cart',
    'page_path': window.location.pathname,
    'site_version': pf_api.siteVersion,
    'id': variant.id,
    'name': variant.product_title,
    'price': variant.price / 100,
    'ecommerce': {
     'currencyCode':'USD',
     'add': {
        'products': [
          {
            'id': variant.variant_id,
            'name': variant.product_title,
            'price': variant.price / 100,
            'brand': 'PRFCT',
            'category': variant.product_type,
            'quantity': quantity
          }
        ]
      }
    }
  });
}

function gtmAddToCart(subscription) {
  dataLayer.push({'product_subscribe': subscription});
}

function initGallery() {
  const galleryOptions = {
    arrows: true,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    initialSlide: 0,
    speed: 400
  };
  $gallerySlider.slick(galleryOptions);
}

document.addEventListener('DOMContentLoaded',() => {

  initGallery();

  formElement.addEventListener('submit',event => {
    event.preventDefault();
  });

  $('[data-scroll-reviews]').on('click',function() {
    var reviewsOffset = $('.product-reviews__container').offset().top;
    $('html,body').animate({
        scrollTop: reviewsOffset - 200
      }, 600);
  });

  $purchaseRadios.on('change', function() {
  const isSubscription = $subscribeRadioTrigger.is(':checked');
  const priceEntry = $('[data-product-price]');
  const rawPrice = parseFloat(priceEntry.attr('data-product-price'));

  if (isSubscription) {
    // 10% Discounted Price
    priceEntry.text('$' + (rawPrice * 0.90).toFixed(2));
    priceEntry.attr('data-strike-out-price', '$' + rawPrice.toFixed(2));
    $('[data-subscription-frequency]').slideDown();
  } else {
    // Original Price
    priceEntry.text('$' + rawPrice.toFixed(2));
    priceEntry.attr('data-strike-out-price', '');
    $('[data-subscription-frequency]').slideUp();
  }
}); 

});

// addItem
async function addItem(variantId, quantity, props, offersSubscription, subscription, name) {
  let sellingPlanId;

  if (window.pf_api && window.pf_api.product && window.pf_api.product.variants && window.pf_api.product.variants[variantId]?.orderLimit && !resumeAfterOrderLimit) {
    pendingOrderLimitAdd = { variantId, quantity, props, offersSubscription, subscription, name };
    buildOrderLimitDialog(variantId);
    return false;
  }

  if (offersSubscription && subscription) {
    sellingPlanId = $frequencySelect.val();
  }

  const items = {
    items: [{ id: variantId, quantity, properties: props, selling_plan: sellingPlanId }]
  };

  const $submitButtonText = $('[data-add-to-cart-text]');
  const defaultTextLabel = $submitButtonText.html();
  $submitButtonText.html('Adding...');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(items)
  })
  .then(response => {
    if (!response.ok) throw new Error('Woops! Inventory limit constraint error occurred.');
    return response.json();
  })
  .then(data => {
    console.info('Custom Drawer Engine Catch Success:', data);

    if (typeof gtmAddToCart === 'function') gtmAddToCart(subscription ? 'yes' : 'no');
    if (typeof dataLayerAdd === 'function') dataLayerAdd(data, quantity);

    $submitButtonText.html('Added to Bag! 🎉');
    setTimeout(() => { $submitButtonText.html(defaultTextLabel); }, 2000);

    const customCartDrawerContainer = document.getElementById('hp-cart-drawer');
    if (customCartDrawerContainer) {
      customCartDrawerContainer.classList.add('active');
      document.body.classList.add('overflow-hidden');

      if (typeof updateCartDrawerDOM === 'function') {
        updateCartDrawerDOM();
      } else {
        fetch('/cart?view=drawer').then(res => res.text()).then(html => {
          const bodyTarget = document.querySelector('[data-cart-drawer-items-js]');
          if (bodyTarget) bodyTarget.innerHTML = html;
        }).catch(e => console.warn('Background drawer rendering pipeline standby:', e));
      }
    } else {
      window.location.href = '/cart';
    }
  })
  .catch((error) => {
    $submitButtonText.html(defaultTextLabel);
    console.error('Core dynamic operational failure tracking error:', error);
    alert('Could not complete operation: Out of Stock or parameters restricted.');
  });
}





window.handleDirectQuickAdd = function(buttonElement, variantId) {
  if (!variantId) return;
  const textLabelNode = buttonElement.querySelector('.btn-text-label');
  const originalText = textLabelNode ? textLabelNode.innerHTML : 'Quick Shop';
  
  if (textLabelNode) {
    textLabelNode.innerHTML = 'Adding...';
  }

  if (typeof window.addItem === 'function') {
    window.addItem(parseInt(variantId), 1, {}, false, false, "")
      .then(() => {
        if (textLabelNode) textLabelNode.innerHTML = originalText;
      })
      .catch(() => {
        if (textLabelNode) textLabelNode.innerHTML = originalText;
      });
  } else {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(res => res.json())
    .then(data => {
      if (textLabelNode) textLabelNode.innerHTML = 'Added!';
      
      const customCartDrawer = document.getElementById('hp-cart-drawer');
      if (customCartDrawer) {
        customCartDrawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
        if (typeof updateCartDrawerDOM === 'function') updateCartDrawerDOM();
      }
      
      setTimeout(() => { if (textLabelNode) textLabelNode.innerHTML = originalText; }, 2000);
    })
    .catch(err => {
      if (textLabelNode) textLabelNode.innerHTML = originalText;
      console.error('Direct click submission error:', err);
    });
  }
};

window.handleBatchQuickAdd = function(buttonElement) {
  
  const sliderContainer = document.querySelector('.hp-sldier-container-outer-quick-shop');
  if (!sliderContainer) {
    console.error("Slider container selector wrapper not found on active viewport.");
    return;
  }

  
  const slideElements = sliderContainer.querySelectorAll('[data-loop-variant-id]');
  if (slideElements.length === 0) {
    console.warn("No active dynamic cards matched within the slider component.");
    return;
  }

  const itemsArray = [];
  
  
  slideElements.forEach(slide => {
    const variantId = slide.getAttribute('data-loop-variant-id');
    if (variantId) {
      itemsArray.push({
        id: parseInt(variantId),
        quantity: 1
      });
    }
  });

  if (itemsArray.length === 0) return;

  
  const textLabelNode = buttonElement.querySelector('.master-btn-text') || buttonElement;
  const originalMasterText = textLabelNode.innerHTML;
  textLabelNode.innerHTML = 'Adding All... ⏳';

  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ items: itemsArray })
  })
  .then(res => {
    if (!res.ok) throw new Error('Multi-items batch validation failed.');
    return res.json();
  })
  .then(data => {
    textLabelNode.innerHTML = 'All Added!';
    
  
    const customCartDrawer = document.getElementById('hp-cart-drawer');
    if (customCartDrawer) {
      customCartDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
      if (typeof updateCartDrawerDOM === 'function') updateCartDrawerDOM();
    }
    
    setTimeout(() => { textLabelNode.innerHTML = originalMasterText; }, 2500);
  })
  .catch(err => {
    textLabelNode.innerHTML = originalMasterText;
    console.error('Batch extraction tracking crash details:', err);
    alert('Failed to process bundle. Check inventory or stock parameters.');
  });
};